import React from 'react';
import { render } from '@testing-library/react';
import { InlineEdit } from './InlineEdit';
import { Input } from '../Input';

describe('InlineEdit', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<InlineEdit
				control={(props: any) => <Input {...props} />}
				onSave={jest.fn()}
				actionDirection="r"
				actionLayout="floating"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass through data automation attributes while editing', () => {
		const { container } = render(
			<InlineEdit
				mode="edit"
				control={(props: any) => <Input {...props} />}
				onSave={jest.fn()}
				actionDirection="r"
				actionLayout="floating"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass data automation attributes to portal', () => {
		const { container, baseElement } = render(
			<InlineEdit
				mode="edit"
				control={(props: any) => <Input {...props} />}
				onSave={jest.fn()}
				actionDirection="r"
				actionLayout="floating"
				portalDataAttributes={{
					'data-auto-sel': 'automation-selector',
				}}
			/>
		);

		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
